import { OnChanges, SimpleChanges } from '@angular/core';
import chaining from '../../../core/helpers/chaining';
import { GRID_VIEW, LIST_VIEW } from '../../../core/helpers/theme-config';
var ProductsLoaderComponent = /** @class */ (function () {
    function ProductsLoaderComponent() {
        this.gridClasses = [];
        this.viewType = GRID_VIEW;
        this.productsCount = 4;
        this.size = 'default';
        this.productsArray = [];
    }
    ProductsLoaderComponent.prototype.ngOnChanges = function (changes) {
        var productsCount = chaining(changes, 'productsCount.currentValue');
        if (productsCount)
            this.productsArray = Array(productsCount).fill(0);
    };
    Object.defineProperty(ProductsLoaderComponent.prototype, "parseGridClasses", {
        get: function () {
            if (Array.isArray(this.gridClasses))
                return this.gridClasses.join(' ');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductsLoaderComponent.prototype, "gridViewType", {
        get: function () {
            return GRID_VIEW === this.viewType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductsLoaderComponent.prototype, "listViewType", {
        get: function () {
            return LIST_VIEW === this.viewType;
        },
        enumerable: true,
        configurable: true
    });
    return ProductsLoaderComponent;
}());
export { ProductsLoaderComponent };
